import React from 'react';

import { LoadingDots } from 'wanderu-components';

import ChikuSearchAnimation from './ChikuSearchAnimation/ChikuSearchAnimation';
import FilterSkeleton from './FilterSkeleton/FilterSkeleton';

import styles from './SearchResultSkeleton.scss';

function SearchResultSkeleton() {
    return (
        <div className={styles.container}>
            <FilterSkeleton className={styles.filterSkeleton} />
            <ChikuSearchAnimation className={styles.chikuAnimation} />
            <LoadingDots className={styles.loadingDots} />
        </div>
    );
}

export default SearchResultSkeleton;
